// takes an array of points, returns the smallest enclosing rectangle
import {siteGeoCode} from "../database/apiv2SiteAccessor"

export function MinRect(props) {
  const xvalues = props.map (point=> point[0])
  const yvalues = props.map(point => point[1])
  const result = {
    x1: Math.min(...xvalues),
    y1: Math.min(...yvalues),
    x2: Math.max(...xvalues),
    y2: Math.max(...yvalues),
  }
  return result
}
export function MapRect (siteList) {
  const arrPoints = getPoints(siteList)
  const points = arrPoints.filter (i=> i !== undefined)
  if (points.length < 2) 
    return ({x1: 26.050581,y1: -123.174576, x2: 51.045762, y2:-72.757065})
  return MinRect(points)
}
export function RectCenter (rect) {
  return [rect.x1+((rect.x2-rect.x1)/2), rect.y1+((rect.y2-rect.y1)/2)]
}
function getPoints(siteList) {
  if (Array.isArray(siteList))
    return siteList.map((site) => siteGeoCode(site))
  if (!siteList)
    return []
  return Array.from(siteList, ([key, value])=>siteGeoCode(value))
}
